import { useEffect } from 'react';
import warning from 'warning';

var usePropWarning = function usePropWarning(props) {
  var children = props.children,
    glyph = props.glyph;
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      process.env.NODE_ENV !== "production" ? warning(!(children && glyph), 'Passing both `children` and `glyph` to <Badge /> will resolve in unexpected behaviour. Please use only one of them.') : void 0;
    }, [children, glyph]);
  }
};
var glyphSizes = new Map([['small', 4], ['medium', 5], ['large', 8]]);

export { glyphSizes, usePropWarning };
